/** sessionStorage key for post-login resolve of digital book email invite */
export const DIGITAL_BOOK_INVITE_STORAGE_KEY = "mysipur_digital_book_invite";
